// Tiny fetch wrapper with JSON handling and error surfacing.
export class HttpClient {
  /**
   * @param {{baseURL:string, defaultHeaders?:Record<string,string>}} cfg
   */
  constructor(cfg) {
    this.baseURL = cfg.baseURL;
    this.defaultHeaders =
      cfg.defaultHeaders || { "Content-Type": "application/json" };
  }

  _url(path) {
    return `${this.baseURL}${path}`;
  }

  async get(path, options = {}) {
    const { noCache = false } = options;
    let url = this._url(path);
    let headers = this.defaultHeaders;
    const init = {
      method: "GET",
      credentials: "include",
    };
    if (noCache) {
      // Defeat any intermediary/browser caching (304 Not Modified, etc.).
      url += (url.includes("?") ? "&" : "?") + `_=${Date.now()}`;
      headers = {
        ...this.defaultHeaders,
        "Cache-Control": "no-cache, no-store, max-age=0",
        Pragma: "no-cache",
      };
      init.cache = "no-store";
    }
    init.headers = headers;
    const res = await fetch(url, init);
    return this._handle(res);
  }

  async post(path, body, headers = {}) {
    const combinedHeaders = { ...this.defaultHeaders, ...headers };

    // If body is FormData, we MUST NOT set Content-Type manually,
    // so the browser can append the boundary string itself.
    if (body instanceof FormData) {
      delete combinedHeaders["Content-Type"];
    }

    const init = {
      method: "POST",
      headers: combinedHeaders,
      credentials: "include",
    };
    if (body !== undefined) {
      init.body = (body instanceof FormData || typeof body === "string") ? body : JSON.stringify(body);
    }
    const res = await fetch(this._url(path), init);
    return this._handle(res);
  }

  async _handle(res) {
    const text = await res.text();
    let data;
    try {
      data = text ? JSON.parse(text) : null;
    } catch {
      data = text;
    }
    if (!res.ok) {
      const err = new Error(
        `HTTP ${res.status} ${res.statusText}: ${typeof data === "string" ? data : JSON.stringify(data)}`
      );
      err.status = res.status;
      err.data = data;
      throw err;
    }
    return data;
  }
}
